
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/jobs/[slug]",
      function () {
        return require("private-next-pages/us/jobs/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/jobs/[slug]"])
      });
    }
  